import { getClientToken } from '../sagAuth';


export const defaultErrorHandler = (error, errorCode) => {
  console.error(`API returned ${errorCode} status code:`, error);

  let errorMessage = 'Some error occured';

  if (error.detail) {
    errorMessage = error.detail;
  }

  if (error.email) {
    errorMessage = error.email[0];
  }

  if (typeof error === 'string') {
    errorMessage = error;
  }

  return { errorMessage, errorCode };
};


export const withClientToken = async ({ action = f => f, args = [] }) => {
  const { token: clientToken, error, errorCode } = await getClientToken();

  if (error) {
    await Promise.reject(defaultErrorHandler(error, errorCode));
  }

  return action(clientToken, ...args);
};



// WEBPACK FOOTER //
// ./src/actions/helpers/tokenHelpers.js